import React, { useEffect, useState } from "react";
import { rolsResource } from "../../helpers/configRoutes/backend_helper";
import { Link, useNavigate } from "react-router-dom";
import DataTableElement from "../../components/elements/DataTableElement";
import { columns } from "./Columns";
import RolModal from "./RolModal";
import { useDispatch } from "react-redux";
import { reset_rol, update_rol } from "../../store/rols/action";
import CustomButton from "../../components/form/CustomButton";
import AddUpdRol from "./AddUpdRol";

const Rols = () => {
    
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [tableLoad, setTableLoad] = useState({
        show: false,
        textLoad: "Loading rol...",
    });

    const [filters,setFilters] = useState({
        perPage: 20,
        page: 1
    });

    const [items, setItems] = useState([]);
    const [modalRow, setModalRow] = useState({ show: false })
    const [modal, setModal] = useState({ show: false })
    

    useEffect(() => {
        const getItems = async () => {
            setTableLoad((prev) => ({ ...prev, show: true }));

            const response = await rolsResource("get", { params: filters });

            if (response.status) {
                setItems(response.rols || []);
            }

            setTableLoad((prev) => ({ ...prev, show: false }));
        };

        getItems();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const openModalAdd = (rolItem = {}) => {
        //VAmos a seteart la funcion de readux para el valor de validation
        dispatch(rolItem.id ? update_rol(rolItem) : reset_rol())
        //
        setModal({
            ...modal,
            show: true,
            title: rolItem.id ? "Edit Supplier" : "Add Supplier",
        });
    };

    const cols = columns(navigate, setModalRow,openModalAdd);

    return (
        <>
            <div className="min-h-screen bg-cs-surface">
                {/* Header */}
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-6">
                    <div>
                        <h1 className="text-2xl font-semibold text-cs-dark">
                            Users Rols
                        </h1>
                        <p className="text-sm text-cs-muted mt-1">
                            Manage rols and permissions of the users.
                        </p>
                    </div>

                    <div className="flex items-center gap-3">
                        <div className="px-3 py-1.5 rounded-xl bg-cs-bg border border-cs-border text-[11px] text-cs-muted">
                            Total user rols:{" "}
                            <span className="font-semibold text-cs-dark">
                                {items.length}
                            </span>
                        </div>
                        <CustomButton
                            onClick={() => openModalAdd()} className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">
                            + Create New User Rol
                        </CustomButton>
                    </div>
                </div>

                {/* Table */}
                <div
                    className="
                        bg-cs-bg border border-cs-border rounded-2xl
                        shadow-sm px-2 py-2
                    "
                >
                    <DataTableElement
                        columns={cols}
                        items={items}
                        tableLoad={tableLoad}
                    />
                </div>
            </div>

            {/* Modals */}
            {modalRow.show &&
                <RolModal modal={modalRow} setModal={setModalRow} />
            }

            {modal.show &&
                <AddUpdRol modal={modal} setModal={setModal} setFilters={setFilters} filters={filters} />
            }
        </>
    );
};

export default Rols;
